import Box from "@mui/material/Box";
import * as React from "react";

export default function ContentBox({ children, ...props }) {
  const { margin, light, sx, ...rest } = props;

  rest.sx = {
    borderRadius: "5px",
    overflow: "hidden",
    background: light ? "transparent" : "#ffffff",
    mt: margin ? 2 : 0,
    mb: margin ? 6 : 0,
    ml: 0,
    mr: 0,
    p: light ? 0 : 2,
    ...sx
  };

  return <Box {...rest}>{children}</Box>;
}
